document.addEventListener('DOMContentLoaded', function() {
  var faqAccordions = document.querySelectorAll('.gl-faq-accordion');

  faqAccordions.forEach(function(faqSection) {
    var faqItems = faqSection.querySelectorAll('.gl-faq-item');

    faqItems.forEach(function(item) {
      var question = item.querySelector('.gl-faq-question');
      var answer = item.querySelector('.gl-faq-answer');

      question.addEventListener('click', function() {
        var isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Close all other items in this accordion
        faqItems.forEach(function(otherItem) {
          var otherQuestion = otherItem.querySelector('.gl-faq-question');
          var otherAnswer = otherItem.querySelector('.gl-faq-answer');

          if (otherQuestion !== question) {
            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.setAttribute('aria-hidden', 'true');
          }
        });

        // Toggle current item
        this.setAttribute('aria-expanded', !isExpanded);
        answer.setAttribute('aria-hidden', isExpanded);
      });
    });
  });
});
